module.exports = __webpack_public_path__ + "static/media/vu-ploytech.a3c3d723.png";